import { CustomError } from './../../models/custom-error';
import { Credential } from './../../models/credential';
import { Injectable } from '@angular/core';
//import { ServerService } from '@pluritech/server-service';
//import { Credential } from './../../models/credential';

import { LoginEndpoints } from './login.endpoints';
import { AuthenticationService } from './../../_services';

@Injectable()
export class LoginService {

  constructor(private authservice: AuthenticationService) 
  
  { }


/*
  public login(credentials: Credential): Promise<any> {
    /*
    return this.serverService.post(LoginEndpoints.login(), credentials)
      .then(res => {
          if (res['kindOfUser'] === 'admin') {
            return res;
          } else {
            throw new CustomError('InvalidKindOfUser', null);
          }
        });
  
  */
/*
}
 public recoveryPassword(email: string): Promise<any> {
    return this.serverService.put(LoginEndpoints.recoveryPassword(), {email: email});
  }
*/
login(credentials: Credential) 
{

  //this.submitted = true;
  // stop here if form is invalid
//  if (this.loginForm.invalid) {
  //    return;
  //}
  //this.loading = true;
  this.authservice.login("123","1111")
       .subscribe(
       data => {
            //if(Response)
             // console.log("test",Loginresponse);
             
             console.log("data",data);
             
             if(data.Data)
             {
              //this.massage=data.Metadata.Message
              //this.router.navigate([this.returnUrl]);
             }
             else
             {
//this.massage=data.Metadata.Message
             }
          },
          error => {

              console.log("error",error);
            //  this.error = error;
             // this.loading = false;
          });


      }


}



// WEBPACK FOOTER //
// ./src/app/providers/login/login.service.ts